export default {
    refresh_devices_config_title: "Refrescar la configuración de lso dispositivos",
    refresh_devices_config_question: "¿Desea refrescar la configuración de los dispositivos?",
    refresh_devices_config_refresh: "Refrescar",
    refresh_devices_config_success_message: "El refresco de la configuración de los dispositivos ha empezado",
}